// Busca de texto para filtros: SUBSTRING e sem acento.
// "indus" acha "Banco Industrial"; "al" acha "Álcool"; "cao" acha "Alimentação".

// Minúsculas e sem diacríticos (á→a, ç→c, ã→a…).
export function norm(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
}

// Todo termo digitado (separado por espaço) precisa aparecer em ALGUM dos campos.
// Ordem livre: "xp mercado" acha uma transação "Mercado" na conta "GIS XP".
export function matchesQuery(fields: (string | null | undefined)[], query: string): boolean {
  const q = norm(query.trim())
  if (!q) return true
  const hay = norm(fields.filter(Boolean).join(' '))
  return q.split(/\s+/).every((t) => hay.includes(t))
}
